<template>
  <v-card>
    <v-card-title>
      <b>Projects</b>
      <v-spacer></v-spacer>
      <router-link
        :to="`/pages/research/client/${$route.params.clientId}/projects`"
        class="mx-2"
      >
        <v-btn small color="primary" outlined>
          <v-icon left small>mdi-format-list-bulleted</v-icon>
          View All Projects
        </v-btn>
      </router-link>
      <a
        :href="`#/pages/research/client/${$route.params.clientId}/new-project`"
        class="mx-4"
      >
        <v-btn
          small
          icon
          class="float-sm-right mt-2 mx-2"
          @click="$emit('createReq')"
        >
          <v-icon class="mr-1">mdi-plus-box-outline</v-icon>
        </v-btn>
      </a>
    </v-card-title>
    <v-divider></v-divider>
    <v-list-item
      v-for="project in projects"
      class="card-shadow border-radius-xl py-2 mb-2"
    >
      <v-list-item-content>
        <v-list-item-title>
          <a
            class="text-h6 font-weight-bold text-decoration-none"
            :href="`#/pages/projects/${project.id}/clusters`"
            >{{ project.name }}</a
          >
        </v-list-item-title>
        <v-list-item-subtitle class="mb-2">
          {{ project.description || 'N/A' }} <br />
        </v-list-item-subtitle>
        <div>
          <v-chip
            :class="{
              flat: !isFailStatus(project),
              red: isFailStatus(project),
              green: isSuccessStatus(project),
            }"
            small
          >
            {{ project.status || 'N/A' }}
          </v-chip>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>
<script>
  export default {
    name: 'ClientProjects',
    methods: {
      isFailStatus(project) {
        return (
          typeof project.status === 'string' &&
          project.status.toLowerCase().includes('fail')
        )
      },
      isSuccessStatus(project) {
        return (
          project.status === 'keywords_clustered' ||
          project.status === 'completed'
        )
      },
    },
    props: {
      projects: {
        type: Array,
      },
    },
  }
</script>
